import React, { useContext, useCallback, useEffect, useRef } from 'react';

const HotjarContext = React.createContext(null);

const { REACT_APP_ENV, REACT_APP_HOTJAR_ID, REACT_APP_HOTJAR_SV } = process.env;

export function HotjarContextProvider({ children }) {
  const hotjarRef = useRef(null);

  const devIdentify = useCallback((...data) => console.log('HJ.identify', ...data), []);
  const devTrackPage = useCallback((...data) => console.log('HJ.trackPage', ...data), []);
  const devCustomEvent = useCallback((...data) => console.log('HJ.customEvent', ...data), []);

  useEffect(() => {
    if (REACT_APP_ENV === 'prod') {
      const { hotjar } = require('react-hotjar');
      hotjar.initialize({
        id: Number(REACT_APP_HOTJAR_ID),
        sv: Number(REACT_APP_HOTJAR_SV)
      });
      hotjarRef.current = hotjar;
    }
  }, []);

  if (REACT_APP_ENV !== 'prod') {
    return (
      <HotjarContext.Provider
        value={{
          identify: devIdentify,
          trackPage: devTrackPage,
          trackCustomEvent: devCustomEvent
        }}
      >
        {children}
      </HotjarContext.Provider>
    );
  }

  return (
    <HotjarContext.Provider
      value={{
        identify: (...args) => hotjarRef.current?.identify(...args),
        trackPage: (...args) => hotjarRef.current?.stateChange(...args),
        trackCustomEvent: (...args) => hotjarRef.current?.event(...args)
      }}
    >
      {children}
    </HotjarContext.Provider>
  );
}

export function useHotjar() {
  const context = useContext(HotjarContext);
  if (!context) throw new Error('useHotjar must be used within a HotjarContext');
  return context;
}
